export default "__VITE_ASSET__BG8$6296__"